module.exports = __webpack_public_path__ + "static/media/grafico.bdacbf4f.png";